let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gvPnc")).then(() => parcelRequire('90FEb'));